import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  SustainabilitySection,
  SectionTitle,
  SectionSubtitle,
  CardContainer,
  Card,
  CardIcon,
  CardTitle,
  CardContent,
  ProductImage
} from './styles';

const Sustainability: React.FC = () => {
  const { language } = useLanguage();
  return (
    <SustainabilitySection>
      <div className="container">
        <SectionTitle>{language === 'pt' ? 'PRODUTOS INOVADORES' : 'INNOVATIVE PRODUCTS'}</SectionTitle>
        <SectionSubtitle>
          {language === 'pt' 
            ? 'Desenvolvemos soluções tecnológicas com foco em inovação e excelência'
            : 'We develop technological solutions focused on innovation and excellence'}
        </SectionSubtitle>
        
        <CardContainer>
          {/* 1. AngolaID */}
          <Card>
            <ProductImage src="/back_imgs/AngolaID.png" alt="AngolaID" />
            <CardTitle>AngolaID</CardTitle>
            <CardContent>
              {language === 'pt'
                ? 'Plataforma de gestão e validação de identificação digital segura com reconhecimento facial.'
                : 'Secure digital identification management and validation platform with facial recognition.'}
            </CardContent>
          </Card>

          {/* 2. AgenteX */}
          <Card>
            <ProductImage src="/back_imgs/AgenteX.png" alt="AgenteX" />
            <CardTitle>AgenteX</CardTitle>
            <CardContent>
              {language === 'pt'
                ? 'Plataforma de IA para automação de operações empresariais, incluindo atendimento ao cliente, vendas e suporte técnico.'
                : 'AI platform for business operations automation, including customer service, sales, and technical support.'}
            </CardContent>
          </Card>

          {/* 3. Rossana Digital */}
          <Card>
            <ProductImage src="/back_imgs/rossanaDigital.png" alt="Rossana Digital" />
            <CardTitle>Rossana Digital</CardTitle>
            <CardContent>
              {language === 'pt'
                ? 'A primeira cantora virtual angolana de R&B e Afrobeats, um projeto artístico-tecnológico que utiliza IA para enriquecer o cenário musical angolano.'
                : 'The first Angolan virtual R&B and Afrobeats singer, an artistic-technological project that uses AI to enrich the Angolan music scene.'}
            </CardContent>
          </Card>
          
          {/* 4. Gabriela */}
          <Card>
            <ProductImage src="/back_imgs/LogoGabriela.png" alt="Gabriela" />
            <CardTitle>Gabriela</CardTitle>
            <CardContent>
              {language === 'pt'
                ? 'Sistema inteligente de gestão documental que automatiza processos e aumenta a eficiência.'
                : 'Intelligent document management system that automates processes and increases efficiency.'}
            </CardContent>
          </Card>
          
          {/* 5. Sawisa */}
          <Card>
            <ProductImage src="/back_imgs/Sawisa.png" alt="Sawisa" />
            <CardTitle>Sawisa</CardTitle>
            <CardContent>
              {language === 'pt'
                ? 'Sistema de gestão clínica com inteligência artificial e telemedicina para o setor de saúde.'
                : 'Clinical management system with artificial intelligence and telemedicine for the healthcare sector.'}
            </CardContent>
          </Card>
        </CardContainer>
      </div>
    </SustainabilitySection>
  );
};

export default Sustainability;